import React from 'react'
import RegisterUser from '../../../components/Register/RegisterUser'

const Su = () => (
  <RegisterUser type="Su"/>
)

export default Su
